import React, { useEffect, useState } from "react";
import SideBar from "../../Common/SideBar/sidebar";
import Navbar from "../../Common/Navbar/navbar";
import { getData } from "../../Common/APIs/api";

const ActiveCarts = () => {
  const [activeCarts, setActiveCarts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    getActiveCartsAPI();
  }, []);

  const getActiveCartsAPI = async () => {
    setLoading(true);
    const endpoint = "admin/active-carts";
    try {
      const response = await getData(endpoint);
      if (response?.success) {
        setActiveCarts(response?.activeCarts || []);
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  };

  // Pagination logic
  const totalPages = Math.ceil(activeCarts.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedCarts = activeCarts.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Generate page numbers to show (max 5 at a time)
  const getPageNumbers = () => {
    const pages = [];
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + 4);
    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f8fafc" }}>
      <SideBar />
      <div className="main-content" style={{ flex: 1, minWidth: 0 }}>
        <Navbar />
        <div style={{ padding: "24px 28px" }}>
          <div className="mb-4">
            <h1 className="page-title" style={{ fontSize: "24px", fontWeight: "600", color: "#1e293b", marginBottom: "8px" }}>Active User Carts</h1>
            <p className="page-subtitle" style={{ color: "#64748b", fontSize: "14px" }}>
              Track what users currently have in their shopping carts.
            </p>
          </div>

          <div className="table-container" style={{ background: "#fff", borderRadius: "12px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
            {loading ? (
              <div>Loading...</div>
            ) : activeCarts.length === 0 ? (
              <div style={{ padding: "20px", textAlign: "center", color: "#64748b" }}>No active carts found.</div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="w-100" style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ borderBottom: "1px solid #e2e8f0", textAlign: "left" }}>
                        <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "600", fontSize: "14px" }}>Customer</th>
                        <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "600", fontSize: "14px" }}>Contact</th>
                        <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "600", fontSize: "14px" }}>Items</th>
                        <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "600", fontSize: "14px" }}>Total Amount</th>
                        <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "600", fontSize: "14px" }}>Last Active</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedCarts.map((cart, index) => (
                        <tr key={index} style={{ borderBottom: "1px solid #f1f5f9" }}>
                          <td style={{ padding: "16px", fontSize: "14px", color: "#334155" }}>
                            <div style={{ fontWeight: "600" }}>{cart.user_name}</div>
                          </td>
                          <td style={{ padding: "16px", fontSize: "14px", color: "#334155" }}>
                            <div>{cart.user_email}</div>
                            <div style={{ color: "#64748b", fontSize: "12px" }}>{cart.user_phone}</div>
                          </td>
                          <td style={{ padding: "16px", fontSize: "14px", color: "#334155" }}>
                            <ul style={{ margin: 0, paddingLeft: "16px" }}>
                              {cart.items.map((item, i) => (
                                <li key={i} style={{ marginBottom: "4px" }}>
                                  {item.name} {item.weight && `(${item.weight})`} x {item.quantity}
                                </li>
                              ))}
                            </ul>
                          </td>
                          <td style={{ padding: "16px", fontSize: "14px", fontWeight: "600", color: "#0f172a" }}>
                            ₹{cart.cart_total.toFixed(2)}
                          </td>
                          <td style={{ padding: "16px", fontSize: "14px", color: "#64748b" }}>
                            {new Date(cart.last_active).toLocaleString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px 16px 0",
                    borderTop: "1px solid #e2e8f0",
                    marginTop: "12px",
                  }}>
                    <div style={{ fontSize: "13px", color: "#64748b" }}>
                      Showing {startIndex + 1}–{Math.min(endIndex, activeCarts.length)} of {activeCarts.length} carts
                    </div>
                    <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                      {/* Prev */}
                      <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #e2e8f0",
                          borderRadius: "6px",
                          background: currentPage === 1 ? "#f8fafc" : "#fff",
                          color: currentPage === 1 ? "#cbd5e1" : "#334155",
                          cursor: currentPage === 1 ? "not-allowed" : "pointer",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        ← Prev
                      </button>

                      {/* Page numbers */}
                      {getPageNumbers().map((page) => (
                        <button
                          key={page}
                          onClick={() => handlePageChange(page)}
                          style={{
                            padding: "6px 12px",
                            border: currentPage === page ? "1px solid #3b82f6" : "1px solid #e2e8f0",
                            borderRadius: "6px",
                            background: currentPage === page ? "#3b82f6" : "#fff",
                            color: currentPage === page ? "#fff" : "#334155",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: currentPage === page ? "600" : "400",
                            minWidth: "36px",
                          }}
                        >
                          {page}
                        </button>
                      ))}

                      {/* Next */}
                      <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #e2e8f0",
                          borderRadius: "6px",
                          background: currentPage === totalPages ? "#f8fafc" : "#fff",
                          color: currentPage === totalPages ? "#cbd5e1" : "#334155",
                          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        Next →
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveCarts;

